import * as React from 'react'
import { Descriptions, Empty } from 'antd'
import { FormattedMessage } from 'react-intl'
import { toggleCreatePayerModal } from '../../Payers'
import { useDispatch } from 'react-redux'
import { taskEither } from 'fp-ts'
import { ShowPayer } from '../../Payers/ShowPayer'
import { searchPayers } from '../../Payers/api'
import styled from 'styled-components'
import AsyncSelect from '../../AsyncSelect'
import { useOrganization } from '@library/react-toolkit'
import { useMode, useRegisteredEmail } from '../queries'
import { Customer } from '../../../types'
import { useOrganizationByName } from '../../../queries'

type Props = {
  value?: Customer
  onChange?: (_: Customer | undefined) => void
  placeholder?: React.ReactNode
}

const SelectRow = styled.div`
  display: flex;
  justify-content: stretch;
  margin-bottom: ${props => props.theme.paddingUnit * 2}px;
  & > .ant-select {
    flex: 1;
    margin-right: ${props => props.theme.paddingUnit}px;
  }
  & > button {
    flex: 0;
  }
`

const getPayerID = (c: Customer) => (c.name === '' ? c.email : c.name)

const SelectPayer = ({ value, onChange, placeholder }: Props) => {
  const mode = useMode()
  const organization = useOrganization()
  const organizationQuery = useOrganizationByName(organization?.name ?? '')
  const registeredEmailQuery = useRegisteredEmail(organization?.name ?? '')

  const dispatch = useDispatch()

  const [selected, setSelected] = React.useState(value)
  const update = (p: Customer | undefined) => {
    setSelected(p)
    if (!!onChange) {
      onChange(p)
    }
  }

  return mode === 'organization' ? (
    <>
      <SelectRow>
        <AsyncSelect
          placeholder={placeholder}
          value={value}
          onSearch={p => {
            update(undefined)
            return !!organization?.name
              ? searchPayers(organization?.name, p)
              : taskEither.of([])
          }}
          onSelect={update}
          render={getPayerID}
          addOption={{
            onClick: () => dispatch(toggleCreatePayerModal()),
            message: <FormattedMessage id="newCustomer" />,
          }}
        />
      </SelectRow>
      {!!selected ? (
        <ShowPayer payer={selected} />
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<FormattedMessage id="noCustomerSelected" />}
        />
      )}
    </>
  ) : (
    <Descriptions column={1} layout="horizontal">
      <Descriptions.Item span={1} label={<FormattedMessage id="name" />}>
        {organization?.name}
      </Descriptions.Item>
      <Descriptions.Item span={1} label={<FormattedMessage id="crNumber" />}>
        {organizationQuery.data === 'Not Found' ||
        !organizationQuery.data ||
        !organizationQuery.data.crNumber ? (
          <FormattedMessage id="noCRNFound" />
        ) : (
          organizationQuery.data.crNumber
        )}
      </Descriptions.Item>
      <Descriptions.Item span={1} label={<FormattedMessage id="address" />}>
        {registeredEmailQuery.data?.email ?? (
          <FormattedMessage id="noAddressFound" />
        )}
      </Descriptions.Item>
    </Descriptions>
  )
}

export default SelectPayer
